import { render, staticRenderFns } from "./08_RegisterFinish.vue?vue&type=template&id=7fc93a60&scoped=true&"
import script from "./08_RegisterFinish.vue?vue&type=script&lang=js&"
export * from "./08_RegisterFinish.vue?vue&type=script&lang=js&"
import style0 from "./08_RegisterFinish.vue?vue&type=style&index=0&id=7fc93a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc93a60",
  null
  
)

export default component.exports